<div class=" font-sans">
  <app-header></app-header>
  <app-banner></app-banner>
  <app-loader></app-loader>
  <app-error-popup></app-error-popup>
  <router-outlet></router-outlet>
</div>